define(['jquery', 'c21/ajax', 'c21/maps/PropertyPaginator', 'c21/maps/TooltipManager'], function ($, ajax, PropertyPaginator, TooltipManager) {
   "use strict";

   return function (map) {
      var self = this,

         m_iPinHeight = 18,
         m_iTooltipPadding = 20,
         m_iYOffset = -m_iPinHeight - m_iTooltipPadding,

         m_map = map,
         m_jHoverTemplate = $("<div class='hoverOverlay propertySummaryHoverOverlay'>&nbsp;<br />&nbsp;<div class='contentTip'></div></div>"),
         m_jClickTemplate = $("<div class='clickOverlay propertySummaryClickOverlay'><div class='contentTip'></div></div>"),
         initClickTooltip = function (jTooltip, pinData) {
            new PropertyPaginator(jTooltip);
            m_jClickTemplate.find(".mapToolTipClose").click(m_tooltipManager.hideClickTooltip);
         },
         getAjaxTooltip = function (strLid, fnCallback) {
            ajax.fetchView({
               subView: 'PropertySummaryOverlay',
               url: '/propertysummary.c21',
               query: $.param({
                  pid: strLid
               }),
               callback: fnCallback
            });
         },
         m_tooltipManager = new TooltipManager(m_map, {
            hoverTemplate: m_jHoverTemplate,
            clickTemplate: m_jClickTemplate,
            initClickTooltip: initClickTooltip,
            getClickHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  var strLid = pinData.getId();

                  // Clear out previous price information
                  m_jClickTemplate.find('.contentTip').empty();

                  getAjaxTooltip(strLid, function () {
                     var jAjaxInfo = $("#propertySummaryClickOverlay"),
                        strHtml = jAjaxInfo.html();

                     dfd.resolve(strHtml);
                  });
               }).promise();
            },
            getHoverHtml: function (pinData) {
               return $.Deferred(function (dfd) {
                  var strLid = pinData.getId();

                  getAjaxTooltip(strLid, function () {
                     var jAjaxInfo = $("#propertySummaryHoverOverlay"),
                        strHtml = jAjaxInfo.html();

                     dfd.resolve(strHtml);
                  });
               }).promise();
            },
            hoverOffset: {
               x: 0,
               y: m_iYOffset,
               tip: -4
            },
            clickOffset: {
               x: 0,
               y: m_iYOffset,
               tip: -4
            }
         }),
         initialize = function () {};

      self.showClickTooltip = m_tooltipManager.showClickTooltip;
      self.showHoverTooltip = m_tooltipManager.showHoverTooltip;
      self.hideHoverTooltip = m_tooltipManager.hideHoverTooltip;
      self.clear = m_tooltipManager.clear;

      initialize();
   };
});
